module.exports = __webpack_public_path__ + "img/DeveloperBoardOutlined.b6832250.svg";